import React, { FunctionComponent } from "react";
import { ListActionButtonProps, IconButton } from "sprint-common-web";

import { TvSeriesListingItem } from "../TvSeriesListingItem";

export interface AddTvSeriesToMergeListButtonProps extends ListActionButtonProps {
    tvSeriesList: TvSeriesListingItem[];
    tvSeriesToMerge: TvSeriesListingItem[];
}

export const AddTvSeriesToMergeListButton: FunctionComponent<AddTvSeriesToMergeListButtonProps> = (
    props: AddTvSeriesToMergeListButtonProps
) => {
    const item = props.tvSeriesList.find((tvSeries: TvSeriesListingItem) => tvSeries.id === props.itemId);
    const isButtonDisabled = (): boolean => {
        return (
            props.disabled ||
            props.tvSeriesToMerge.some(
                (tvSeries: TvSeriesListingItem) => tvSeries.id === item?.id || !tvSeries.buzzId === !item?.buzzId
            ) ||
            !!item?.merged
        );
    };

    return (
        <IconButton
            key={props.id}
            iconProps={{ iconName: "Merge" }}
            disabled={isButtonDisabled()}
            onClick={props.onClick}
            tooltipContent="Add to merge list"
        />
    );
};
